import { ComponentProps } from 'react';
import { twMerge } from 'tailwind-merge';

export type InfoProps = ComponentProps<'div'>;

export function Info({ className, ...props }: InfoProps) {
  return (
    <div
      className={twMerge(
        'flex flex-col overflow-x-hidden text-sm font-light lg:text-lg',
        className,
      )}
      {...props}
    />
  );
}
